'use client'

import { useServerInsertedHTML } from 'next/navigation'
import { useRef } from 'react'

import { PUBLIC_ENV_KEY } from '@/constants/env'

type PublicEnvScriptClientProps = { env: Record<string, string | undefined> }

// Injects <script> into the SSR HTML stream outside React's reconciliation,
// sidestepping the React 19 warning for script tags in render output.
export default function PublicEnvScriptClient({ env }: PublicEnvScriptClientProps) {
  const inserted = useRef(false)

  const innerHTML = {
    __html: `window['${PUBLIC_ENV_KEY}'] = ${JSON.stringify(env)}`,
  }

  useServerInsertedHTML(() => {
    if (inserted.current) return
    inserted.current = true
    return <script dangerouslySetInnerHTML={innerHTML} />
  })

  return null
}
